import './EditionPage.scss';
import { SimpleNumberCard } from '@design-system/index';
import { PrestationsFinancieresLine } from '@icons';
import { MutationTable } from '@components/Table/MutationTable/MutationTable';
import { ColumnDef } from '@tanstack/react-table';
import { useFinancialBenefitEditionPageVM } from './useEditionPageVM';
import { FinancialBenefit } from '@services/member/member/member.types';
import { useGetFinancialBenefitsEditionMutation, useGetFinancialBenefitsExportMutation } from '@services/member/list/financial-benefits/financial-benefits.endpoints';
import { FinancialBenefitListItem } from '@services/member/list/financial-benefits/financial-benefits.types';
import { formatDate } from '@utils/dates';
import { formatMoney } from '@utils/numbers';

export default function TicketingEditionPage() {
    const {
        handleMetadata,
        columnHelper,
        financialBenefitsItems,
        totalFinancialBenefits
    } = useFinancialBenefitEditionPageVM();

    const columns = [
        columnHelper.accessor((row) => row.memberCosemNumber, {
            header: 'N° COSEM',
            id: 'member.cosemNumber',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.memberName, {
            header: 'Adhérent',
            id: 'member.personalInformation.lastname',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.code, {
            header: 'Code',
            id: 'code',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{info.getValue()}</>
        }),
        columnHelper.accessor((row) => row.requestedAt, {
            header: 'Date de demande',
            id: 'requestedAt',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{formatDate(info.getValue())}</>
        }),
        columnHelper.accessor((row) => row.amount, {
            header: 'Montant',
            id: 'amount',
            enableSorting: true,
            meta: {
                clickable: true
            },
            cell: (info) => <>{formatMoney(info.getValue())}</>
        }),
        columnHelper.accessor((row) => row.isArchived, {
            id: 'isArchived',
            header: 'Archivé',
            meta: {
                clickable: true
            },
            enableSorting: true,
            cell: (info) => <>{info.getValue() ? 'Oui' : 'Non'}</>
        })
    ] as ColumnDef<FinancialBenefit>[];

    return (
        <div className="members-table-container">
            <div className="members-table-container-header">
                <div className="members-table-container-header-left">
                    <SimpleNumberCard
                        labelForSingle={'Prestation'}
                        labelForMultiple={'Prestations'}
                        value={totalFinancialBenefits}
                    />
                </div>
            </div>
            <MutationTable
                key={'edition'}
                columns={columns}
                selectable={false}
                mutationHook={useGetFinancialBenefitsEditionMutation}
                defaultSorting={{
                    field: 'createdAt',
                    direction: 'desc'
                }}
                exportable={true}
                exportMutationHook={useGetFinancialBenefitsExportMutation}
                headerTitle={'Édition prestations financières'}
                headerIcon={<PrestationsFinancieresLine />}
                headerIconColor="green-water"
                onMetadata={handleMetadata}
                filters={[
                    {
                        id: 'requestedAt',
                        label: 'Date de demande',
                        type: 'date',
                        comparatorTypes: ['isBetween', 'isBefore', 'isAfter', 'equals']
                    },
                    {
                        id: 'code',
                        label: 'Code',
                        type: 'select',
                        options: financialBenefitsItems.map((financialBenefit: FinancialBenefitListItem) => ({ label: financialBenefit.label, value: financialBenefit.code }))
                    },
                    {
                        id: 'isArchived',
                        label: 'Archivé',
                        type: 'boolean'
                    }
                ]}
            />
        </div>
    );
}
